<template>
  <div class="package-containeer">
    <div class="top-container">
      <div class="left-container">
        <base-button
          type="button"
          class="button"
          @click="
            $router.push({
              name: 'BuyRecomendedPackage',
              params: { customerNumber: 0 },
              query: { isRecommended: 1 },
            })
          "
          >En Çok Kullanılan Paket Oluştur</base-button
        >
      </div>
      <div class="right-container">
        <recommended-packages-filters />
      </div>
    </div>
    <list-view-skeleton v-if="isDataLoaded" :line-count="10" />

    <recommended-packages-table
      v-else
      :key="d.id"
      :allData="recommendedAllPackages.data"
      v-for="(d, index) in recommendedAllPackages.data"
      :dataItem="{
        title: d.productName,
        subtitle: d.platform ? d.platform.name : '',
        imageUrl: d.imageUrl,
        ...d,
      }"
      :index="index"
      @isRequestSended="loadingChecker($event)"
      @isRequestFinished="loadingChecker($event)"
    />
    <recommended-packages-pager
      :pageName="'dataRequest'"
      :page="recommendedAllPackages.page"
      v-if="recommendedAllPackages.page"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import {
  RecommendedPackagesFilters,
  RecommendedPackagesTable,
  RecommendedPackagesPager,
  BaseButton,
} from "@/components";
const ListViewSkeleton = () =>
  import(/* webpackPrefetch: true */ "@/components/base/ListViewSkeleton");
export default {
  name: "RecommendedPackages",
  data() {
    return {
      isDataLoaded: false,
    };
  },
  components: {
    RecommendedPackagesFilters,
    RecommendedPackagesTable,
    RecommendedPackagesPager,
    BaseButton,
    ListViewSkeleton,
  },
  computed: {
    ...mapGetters(["recommendedAllPackages"]),
  },
  methods: {
    ...mapActions(["getRecommendedAllPackageList"]),
    ...mapMutations(["setGeneralFilter"]),
    loadingChecker(param) {
      if (!param) {
        setTimeout(() => {
          this.isDataLoaded = param;
        }, 300);
      } else {
        this.isDataLoaded = param;
      }
    },
    subtitleChecker(d) {
      if (d.platform != null) {
        return d.platform.name;
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.setGeneralFilter({
      filter: {
        Status: 2,
      },
    });
    this.getRecommendedAllPackageList();
  },
};
</script>
<style lang="scss" scoped>
.package-containeer {
  width: auto;
  margin: 0px 20px;
}
.top-container {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  .left-container {
    width: 20%;

    @media (max-width: 768px) {
      width: 100%;
      text-align: center;
    }

    .button {
      max-width: 250px;
      width: 100%;
      min-height: 48px;
      height: auto;

      margin-top: 15px;
    }
  }
  .right-container {
    width: 80%;
    @media (max-width: 768px) {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
